<template>
    <div class="home">
        <AppHeader />
        <AppNav />
        <div class="home-content">
            <div class="container d-grid">
                <div class="row justify-content-sm-center">
                    <div class="col-12  ">
                        <h1 class="heading justify-content-sm-center mx-4">Madresatul Banaat Almuslimaat:<br>Muslim Girls
                            School</h1>
                        <p class="paragraph justify-content-sm-center mx-4">It began with a vision…to organize an
                            institution for the education of Muslim
                            girls in
                            an Islamic environment. Beginning with a small school with only 4 classrooms, we have expanded
                            over the
                            years to what is now a full facility school with two floors, offering education from JK – Grade
                            12.
                            Alhamdulillah, we are serving a population of ~5, 000 Muslims in the immediate vicinity of the
                            school
                            (Etobicoke). In addition to this, many of our students travel from our neighbouring cities such
                            as
                            Mississauga, Brampton, Richmond Hill, Barrie and Woodbridge to attend our school. Our students
                            come from
                            a diverse array of families and ethnic backgrounds. As a non-profit, charitable organization, we
                            also
                            offer education to orphans and children from single mothers, widows, or less fortunate parents,
                            who are
                            helped through our Zakaat fund.
                            Our school facilities are also being used by other members of our community for programs such as
                            Arabic
                            language studies, which are held at our school on the weekends.
                            Thanks.</p>
                        <div class="overlay-background"></div>

                    </div>
                </div>
            </div>

        </div>
    
        <div class="container ">
            <div class="row  justify-content-center">
                <div class=" col-12 mx-0">
                    <div class="message my-5">
                        <div class="overlay-message ">
                            <div class="row justify-content-center">
                                <div class="col text-center">
                                    <h1 class="heading">Message from Principal</h1>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col text-start">
                                    <h1 class="announcement-1-heading" style="padding-left: 88px;">Dear Students, Parents
                                        and
                                        Guardians,</h1>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-lg-6 col-md-8 col-9 mx-0">
                                    <div class="overlay-content p-4 ">
                                        <div class="text-content fs-6">
                                            Welcome back to Madresatul Banaat Almuslimeen/Almuslimaat, for the 2024-2025
                                            school
                                            year! I hope you all
                                            came back refreshed, rejuvenated, and ready for another year of learning,
                                            growth,
                                            and
                                            community building.
                                            As we embark on this new academic journey together, I want to take a moment to
                                            express
                                            my heartfelt
                                            gratitude to each and every one of you. The past years have posed their share of
                                            challenges, but your
                                            resilience, dedication, and unwavering support have truly made a difference.
                                            Together,
                                            we have shown that,
                                            as a community, we can overcome any obstacle that comes our way.
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-5 col-md-8 col-9 mx-0 ">
                                    <img src="@/assets/message.png" class="img-fluid rounded mx-auto d-block">
                                </div>
                            </div>
                            <div class="row justify-content-center">

                                <div class="col-lg-12 col-12 mx-auto">
                                    <div class="overlay-content-continue my-5  fs-6">
                                        <b
                                            style="color: #700000;font-family: 'Raleway', sans-serif;font-size: 20px;font-style: normal;font-weight: 600;line-height: 30px;letter-spacing: 0.2px;">For
                                            our students</b>, this year offers a fresh opportunity to explore new subjects,
                                        cultivate talents, and
                                        make lasting friendships. Remember, the school is not just a place to gain knowledge
                                        but
                                        a
                                        platform to
                                        develop life skills, empathy, and a sense of responsibility that will serve you well
                                        beyond
                                        these walls.

                                        <br><br><b
                                            style="color: #700000;font-family: 'Raleway', sans-serif;font-size: 20px;font-style: normal;font-weight: 600;line-height: 30px;letter-spacing: 0.2px;">To
                                            our esteemed staff</b>, your commitment to fostering an enriching learning
                                        environment
                                        is truly
                                        commendable. Your passion, expertise, and hard work lay the foundation for our
                                        students’
                                        success. Your
                                        dedication does not go unnoticed, and I am excited to witness the positive impact
                                        you
                                        will
                                        continue to have
                                        on our school community.

                                        <br><br><b
                                            style="color: #700000;font-family: 'Raleway', sans-serif;font-size: 20px;font-style: normal;font-weight: 600;line-height: 30px;letter-spacing: 0.2px;">Families</b>,
                                        you are an integral part of our school’s success. Your unwavering support,
                                        engagement,
                                        and
                                        collaboration
                                        play a pivotal role in creating a thriving educational ecosystem. Let’s work hand in
                                        hand to
                                        ensure the best
                                        possible educational experience for our students.
                                        <br><br>
                                        Throughout this school year, we will continue to prioritize safety, well-being, and
                                        open
                                        communication. We
                                        remain vigilant in our efforts to maintain a healthy and secure learning
                                        environment,
                                        following the guidance
                                        of health authorities to mitigate any challenges that may arise.
                                        I encourage you to take advantage of the various opportunities our school offers –
                                        academic,
                                        extracurricular, and community engagement. These experiences enrich our lives and
                                        contribute
                                        to the vibrant
                                        tapestry of our school community.
                                        Please stay tuned for updates on important dates, events, and initiatives through
                                        our
                                        school’s communication
                                        channels. Feel free to reach out to us with any questions, suggestions, or concerns
                                        you
                                        may
                                        have. We are
                                        here to support you in every way possible.
                                        Once again, welcome back to Madresatul Banaat Almuslimeen/Almuslimaat! Let’s make
                                        this
                                        academic year one of
                                        discovery, growth, and accomplishment. Together, we can create a positive and
                                        nurturing
                                        environment where
                                        each individual shines brightly.
                                        <br>
                                        <br>
                                        <b class="sig">Here’s to a successful and rewarding 2024-2025 school year!</b>
                                        <br><br>
                                        <b class="name" style="font-size: 20px;">Warm regards,</b><br>
                                        <b class="name" style="font-size: 20px;">School Principal,</b><br>
                                        <b class="name" style="font-size: 20px;">Syed A. Qadri</b><br>

                                    </div>
                                    <br><br>

                                </div>
                            </div>
                            
                        </div>



                    </div>
                </div>
            </div>
        </div>
        <div class="announcement">
            <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <div class="cards-wrapper">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">We are Hiring @.</h5>
                                    <p class="announcement-1-subheading">Primary and High School Teachers Wanted!</p>
                                    <p class="card-text">Are you passionate about shaping young minds and making a lasting
                                        impact on the future? We are excited to announce openings for dedicated and
                                        enthusiastic Primary and
                                        High School Teachers to join our dynamic educational institution.
                                        Positions: Primary School Teacher / High School Teacher / Math Teacher (Urgent)
                                        Location: 10 Vulcan Street Etobicoke Ontario, M9W1L2
                                    </p>
                                    <router-link to="/employment" @click="scrollToTop" class="btn announcement-action-button ">Read more</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <div class="cards-wrapper">
                            <div class="card">
                                <div class="card-body">
                                <h5 class="card-title">2024-2025 School Registration:</h5>

                                <br><br>
                        <div class="centered">
                            <a href="/mba-registration" class="announcement-button btn w-100">
                                 Registration Information for 2024-2025 School Year
                            </a>
                        </div>
                                <br>
                        <div class="centered">
                            <a href="/maa-registration-form.pdf" download class="announcement-button btn w-100">
                                M.A.A Registration Form (JK To Gr-5)
                             </a>
                        </div>
                                <br>
                        <div class="centered">
                            <a href="/mba-registration-form.pdf" download class="announcement-button btn w-100">
                                M.B.A Registration Form (Gr-6 To Gr-12)
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                    <div class="carousel-item">
                        <div class="cards-wrapper">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Toronto Science Fair 2024</h5>
                                    <p class="announcement-1-subheading">Primary and High School Teachers Wanted!</p>
                                    <p class="card-text">I am thrilled to share the outstanding news of our students’
                                        achievements at the Toronto Science Fair 2024. Our students from Grades 6, 8, and 10
                                        have shown
                                        exceptional talent, dedication, and innovation, resulting in their winning silver
                                        and bronze medals,
                                        as well as the special OACETT Award.

                                        Our hounored and Price wining students are… <br><b class="bold">Grade
                                            6:</b> <b class="name">Sumaya Yasin</b> won a Bronze Medal <br><b
                                            class="bold">Grade 8:</b> <b class="name">Esha Rashid</b> won the (OACETT)
                                        Special Award and a Silver Medal for her Science
                                        Project: “Robo-Arm”
                                    </p>
                                    <router-link to="/about-us" @click="scrollToTop" class="btn announcement-action-button ">Read more</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
                    data-bs-slide="prev" style="background-color: #700000;">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
                    data-bs-slide="next" style="background-color: #700000;">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>

        </div>

        <AppFooter />
    </div>
</template>
  
<script>
import AppHeader from '@/components/AppHeader.vue';
import AppNav from '@/components/AppNav.vue';
import AppFooter from '@/components/AppFooter.vue';
import { onMounted, onUnmounted } from 'vue';

export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Home',
    components: {
        AppHeader,
        AppNav,
        AppFooter
    },
    setup() {
        onMounted(() => {
            document.title = 'Muslim Girl School';
        });

        onUnmounted(() => {
            document.title = 'Muslim Girl School';
        });
    },

}
</script>
  
<style scoped>
.text-content {
    color: rgba(0, 0, 0, 0.78);
    font-family: Raleway;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
    letter-spacing: 0.24px;
    margin-bottom: 1em;
}

.right-side-image {
    flex-shrink: 0;
    margin-top: -170px;

}

.message-button {
    width: 100%;
    height: 80px;
    border-radius: 6px;
    background: #700000;
    color: #EBE3D8;
    font-family: 'Raleway', sans-serif;
    font-style: normal;
    font-weight: 700;
    line-height: 44px;
    letter-spacing: 0.28px;
    cursor: pointer;

}

.sig {
    color: #000;
    font-family: 'Raleway', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: 0.2px;
}

.overlay-content-continue {
    position: relative;
    color: rgba(0, 0, 0, 0.52);
    font-family: 'Raleway', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: 0.2px;
    padding: 75px;
    padding-bottom: 0px;
}

.overlay-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.overlay-message {
    border: 4px solid #EBE3D8;
    position: relative;
    z-index: 2;
    top: -18px;
    left: 8px;
}

.message {
    z-index: 1;
    position: relative;
    left: 50%;
    border: 4px solid #700000;
    transform: translate(-50%, 0%);
}

.name {
    color: #700000;
    font-family: 'Raleway', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.14px;
}

.bold {
    color: #000;
    font-family: 'Raleway', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.14px;
}

.announcement-action-button {
    border-radius: 3px;
    background: #700000;
    color: #FFF;
    font-family: 'Raleway', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.14px;
    width: 128px;
    height: 40px;
    cursor: pointer;
}

.announcement-button {
    padding: 15px;
    flex-shrink: 0;
    color: #FFF;
    font-family: 'Raleway', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.14px;
    cursor: pointer;
    border-radius: 3px;
    background: #700000;
}

.announcement-1-content {
    color: rgba(0, 0, 0, 0.82);
    font-family: 'Raleway', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 35px;
    letter-spacing: 0.14px;
}

.announcement-3-content {
    color: rgba(0, 0, 0, 0.82);
    font-family: 'Raleway', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 25px;
    letter-spacing: 0.14px;
}

.announcement-1-read {
    color: #700000;
    font-family: 'Raleway', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 22px;
    letter-spacing: 0.14px;
    text-decoration-line: underline;
}

.announcement-1-subheading {
    color: #000;
    font-family: 'Merriweather';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.16px;
}

.announcement-1-heading {
    color: #000;
    font-family: 'Merriweather';
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px;
    letter-spacing: 0.24px;
}

.announcement-1 {
    padding: 20px;
    border-radius: 5px;
    border: 3px solid #700000;
    background: #FFF;
    height: 446px;
    width: 378px;

}

.announcement-2 {
    padding: 20px;
    border-radius: 5px;
    border: 3px solid #700000;
    background: #FFF;
    height: 446px;
    width: 378px;
    margin-left: 50px;
}

.announcement-title {
    padding-top: 50px;
    padding-left: 88px;
    color: rgba(0, 0, 0, 0.78);
    font-family: 'Merriweather';
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px;
    letter-spacing: 0.36px;
}

.announcement-content {
    display: inline-flex;
    justify-content: space-between;
    padding-left: 88px;
}

.home-content {
    position: relative;
    background-image: url('@/assets/computer-lab.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: fit-content;
    z-index: 0;
    display: grid;
}

.overlay-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(92deg, #FFF 20.85%, rgba(255, 255, 255, 0.00) 99.03%);
    z-index: -1;

}


.heading {
    padding-top: 30px;
    color: #700000;
    font-family: 'Merriweather';
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px;
    letter-spacing: 0.36px;
    z-index: 10;
}

.paragraph {
    color: #000;
    font-family: 'Raleway', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 35px;
    letter-spacing: 0.16px;
    /* width: 50%; */
    z-index: 10;
}

.announcement {
    background-color: #EBE3D8;
}


.title {
    color: #EBE3D8;
    text-align: center;
    font-family: 'Merriweather';
    font-size: 96px;
    font-style: normal;
    font-weight: 700;
    line-height: 100px;
    letter-spacing: 0.96px;
}

.header-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 2;
}

@media screen and (max-width: 450px) {
    .home-content {
        justify-content: center;
    }
}

.cards-wrapper {
    display: flex;
    justify-content: center;
}

.card img {
    max-width: 100%;
    max-height: 100%;
}

.card {
    margin: 0 0.5em;
    box-shadow: 2px 6px 8px 0 rgba(22, 22, 26, 0.18);
    border: none;
    border-radius: 0;
    height: fit-content;
    width: 500px;
    padding: 20px;
    border-radius: 5px;
    border: 3px solid #700000;
    min-width: 300px;
}

.card-text {
    color: rgba(0, 0, 0, 0.82);
    font-family: 'Raleway', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 35px;
    letter-spacing: 0.14px;
}

.carousel-inner {
    padding: 2em 5em;
}

.card-body {
    height: fit-content;
    max-height: 1000px;
}

.card-title {
    color: #000;
    font-family: 'Merriweather';
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 50px;
    letter-spacing: 0.24px;
}

.carousel-control-prev,
.carousel-control-next {
    background-color: #e1e1e1;
    width: 5vh;
    height: 5vh;
    border-radius: 50%;
    top: 50%;
    transform: translateY(-50%);
}

@media (min-width: 768px) {
    .card img {
        height: 11em;
    }
}
</style>
  